export enum PaymentFrequencyEnum {
    Monthly = "Monthly",
    Every3Months = "Every3Months",
    Yearly = "Yearly",
    Month = "Month",
    Day = "Day",
    Year = "Year",
    Annual = "Annual",
    Quarterly = "Quarterly"
}